var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 1.375H2.0625C1.88016 1.375 1.7053 1.44743 1.57636 1.57636C1.44743 1.7053 1.375 1.88016 1.375 2.0625V8.9375C1.375 9.11984 1.44743 9.2947 1.57636 9.42364C1.7053 9.55257 1.88016 9.625 2.0625 9.625H8.9375C9.11984 9.625 9.2947 9.55257 9.42364 9.42364C9.55257 9.2947 9.625 9.11984 9.625 8.9375V2.0625C9.625 1.88016 9.55257 1.7053 9.42364 1.57636C9.2947 1.44743 9.11984 1.375 8.9375 1.375Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08 6.83719L4.3764 5.54079L5.38198 6.54385L7.79167 4.125",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 4.125H7.79167V5.95833",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.a582a5b7c143af0d9be64f8f627c982d.svg";
export { ForwardRef as ReactComponent };